// 다국어 문자열 및 정책. 새 언어를 추가하려면 KO/EN 객체 구조를 그대로 복제하세요.

export const LANGUAGES = [
  { value: 'ko', label: '한국어', short: '한' },
  { value: 'en', label: 'English', short: 'EN' },
];

const STORAGE_KEY = 'app-language';

export function detectLanguage() {
  if (typeof window === 'undefined') return 'ko';
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === 'ko' || saved === 'en') return saved;
  } catch {
    /* ignore */
  }
  const nav = (window.navigator && window.navigator.language) || '';
  return nav.toLowerCase().startsWith('ko') ? 'ko' : 'en';
}

export function persistLanguage(lang) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
}

// ---------- 단위계 (미터법 / 임페리얼) ----------
// 언어와 무관하게 동작. 미국·라이베리아·미얀마 로케일만 임페리얼 기본값.

const UNITS_STORAGE_KEY = 'app-units';
const IMPERIAL_LOCALES = /^(en-US|en-LR|my)\b/i;

export const UNIT_SYSTEMS = [
  { value: 'metric', label: 'cm·kg' },
  { value: 'imperial', label: 'ft·lb' },
];

export function detectUnits() {
  if (typeof window === 'undefined') return 'metric';
  try {
    const saved = window.localStorage.getItem(UNITS_STORAGE_KEY);
    if (saved === 'metric' || saved === 'imperial') return saved;
  } catch {
    /* ignore */
  }
  const nav = (window.navigator && window.navigator.language) || '';
  return IMPERIAL_LOCALES.test(nav) ? 'imperial' : 'metric';
}

export function persistUnits(units) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(UNITS_STORAGE_KEY, units);
  } catch {
    /* ignore */
  }
}

const KO = {
  htmlLang: 'ko',
  docTitle: 'AI 퍼스널 스타일리스트 | 1분 만에 받는 맞춤 스타일 리포트',
  appTitle: 'AI 퍼스널 스타일리스트',
  back: '뒤로',
  close: '닫기',
  langSwitcher: '언어',

  // ── 인증 ──
  authLogin: '로그인',
  authLogout: '로그아웃',
  authSignup: '회원가입',
  authModalLoginTitle: '로그인',
  authModalSignupTitle: '회원가입',
  authEmail: '이메일',
  authPassword: '비밀번호',
  authPasswordPlaceholder: '6자 이상',
  authSubmitLogin: '로그인',
  authSubmitSignup: '회원가입',
  authSwitchToSignup: '계정이 없으신가요? 회원가입',
  authSwitchToLogin: '이미 계정이 있으신가요? 로그인',
  authGoogle: 'Google 로 계속',
  authOrDivider: '또는',
  authSignupSuccess: '확인 이메일을 보냈어요. 받은편지함을 확인해 주세요.',
  authSignupSuccessNoConfirm: '가입 완료! 로그인되었습니다.',
  authForgotPassword: '비밀번호를 잊으셨나요?',
  authForgotPasswordSent: '재설정 링크를 이메일로 보냈습니다.',
  authError: (msg) => `오류: ${msg}`,
  authAccountMenu: '계정',
  authMyPage: '마이페이지',

  // ── 마이페이지 ──
  myPageTitle: '마이페이지',
  myPageInfoSection: '내 정보',
  myPageEmail: '이메일',
  myPageProvider: '로그인 방식',
  myPageProviderEmail: '이메일',
  myPageProviderGoogle: 'Google',
  myPageJoined: '가입일',
  myPageDisplayName: '닉네임',
  myPageDisplayNamePlaceholder: '표시될 이름',
  myPageSaveName: '저장',
  myPageNameSaved: '저장됐어요.',

  myPagePasswordSection: '비밀번호 재설정',
  myPageNewPassword: '새 비밀번호',
  myPageNewPasswordPlaceholder: '6자 이상',
  myPageConfirmPassword: '비밀번호 확인',
  myPagePasswordSubmit: '변경',
  myPagePasswordMismatch: '비밀번호가 일치하지 않습니다.',
  myPagePasswordTooShort: '비밀번호는 6자 이상이어야 합니다.',
  myPagePasswordChanged: '비밀번호가 변경되었습니다.',
  myPagePasswordNotForOAuth: '소셜 로그인 계정은 비밀번호 변경이 불가합니다. 해당 소셜 계정에서 비밀번호를 관리해 주세요.',

  myPageDangerSection: '회원 탈퇴',
  myPageDeleteWarning: '탈퇴 시 계정과 관련된 모든 데이터가 즉시 삭제되며 복구할 수 없습니다.',
  myPageDeleteConfirmLabel: '확인을 위해 본인의 이메일을 입력해 주세요',
  myPageDeleteBtn: '계정 영구 삭제',
  myPageDeleting: '삭제 중...',
  myPageDeleteEmailMismatch: '이메일이 일치하지 않습니다.',
  myPageDeleteFail: (err) => `탈퇴 실패: ${err}`,
  myPageBack: '뒤로',
  myPageDeleteSuccess: '안전하게 탈퇴 처리되었어요. 마음이 바뀌시면 언제든 다시 만나요.',

  pwRecoveryTitle: '새 비밀번호 설정',
  pwRecoverySubtitle: '안전한 비밀번호를 입력해 주세요. 변경하면 자동으로 로그인됩니다.',
  pwRecoverySaved: '비밀번호가 변경되었습니다.',
  pwRecoveryCancel: '취소하고 로그아웃',

  // ── Aura Daily 구독 CTA ──
  subBadge: 'AURA DAILY',
  subTitle: '매일 아침, 오늘 입을 옷이 도착해요',
  subSubtitle: '오늘 날씨와 당신의 스타일 프로필 기반으로 AI가 매일 아침 한 벌을 골라드립니다. 7일 무료, 언제든 취소.',
  subBullet1: '매일 한 벌의 완성된 코디 + 백업 시안',
  subBullet2: '당신의 도시 날씨 자동 반영',
  subBullet3: '주말엔 lookbook 1장',
  subPriceMonthly: '월 $9.99',
  subPriceUnit: '하루 약 $0.33 꼴',
  subPriceTrialBadge: '7일 무료 후 결제',
  subCta: '7일 무료로 시작',
  subCtaBusy: '결제 페이지로 이동 중...',
  subChipsLabel: '구독 안심 보장',
  subChip1: '7일 무료',
  subChip2: '언제든 취소',
  subChip3: '지금은 청구 없음',
  subTrustLine: '카드 등록은 필요해요. 8일째부터 결제되고, 그 전 48시간 안내 이메일 발송.',
  subSubscribedToastTitle: '구독 시작!',
  subSubscribedToast: '환영합니다 — 내일 아침부터 매일 brief 가 도착합니다.',
  subErrorNeedLogin: '구독은 로그인 후 시작할 수 있습니다.',

  // ── 랜딩 히어로 ──
  heroEyebrow: 'AI 퍼스널 스타일링',
  heroTitle: '오늘 뭐 입지, 더는 고민하지 마세요',
  heroSubtitle: '사진 한 장이면 충분합니다. 매일 아침 코디를 받아보는 구독, 또는 한 번에 끝내는 정밀 스타일 리포트 — 원하는 방식으로 시작하세요.',
  heroCtaSub: '매일 코디 구독 · 7일 무료',
  heroCtaReport: '1회 스타일 리포트 · $6.99',
  heroVisualAlt: '오늘의 코디를 받아보는 AI 퍼스널 스타일리스트',
  heroVisualCaption: '오늘의 무드',
  heroBadge: '7일 무료 체험 · 언제든 취소 · 카드 즉시 청구 없음',

  // ── 구독 설명 쇼케이스 ──
  subShowTag: 'AURA DAILY · 구독',
  subShowTitle: '매일 아침, 오늘의 한 벌이 메일함에',
  subShowDesc: '당신의 도시 날씨와 체형·취향을 학습한 AI가 매일 아침 완성된 코디 한 벌과 착장 이미지를 보내드려요. 고민 없이 그대로 입고 나가기만 하면 됩니다.',
  subShowPoint1: '오늘 하루 날씨에 딱 맞춘 코디',
  subShowPoint2: '실제 착장 이미지로 한눈에 확인',
  subShowPoint3: '주말엔 lookbook 한 장 추가',
  subShowCta: '7일 무료로 시작하기',
  // 미리보기 목업(메일 카드) 라벨
  subShowMockKicker: 'AURA DAILY',
  subShowMockDate: '5월 30일 금요일',
  subShowMockWeather: '21°–29°C · 맑음 · 강수 0%',
  subShowMockLine1: '오늘은 라이트 베이지 셋업에 화이트 이너로 산뜻하게.',
  subShowMockLine2: '햇살이 강하니 가벼운 리넨 소재를 추천해요.',
  subShowMockImageAlt: '오늘의 완성된 코디 한 벌 예시',

  // ── 1회 리포트 설명 쇼케이스 ──
  repShowTag: '1회 결제 · 리포트',
  repShowTitle: '딱 한 번의 정밀 스타일 진단',
  repShowDesc: '체형 분석, 퍼스널 컬러, 어울리는·피해야 할 스타일, 그리고 어울리는 헤어스타일 6종 이미지까지. 1회 $6.99로 두고두고 참고할 나만의 스타일 가이드를 받으세요.',
  repShowPoint1: '퍼스널 컬러 & 체형 분석',
  repShowPoint2: '추천 헤어스타일 6종 이미지',
  repShowPoint3: '구독 아님 · 자동결제 없음',
  repShowCta: '1회 분석 시작하기',
  // 미리보기 목업(리포트 카드) 라벨
  repShowMockKicker: 'STYLE REPORT',
  repShowMockColor: '퍼스널 컬러 · 가을 웜 뮤트',
  repShowMockBody: '체형 · 균형 잡힌 스트레이트',
  repShowMockHair: '추천 헤어스타일 6종',
  repShowMockHairAlt: '추천 헤어스타일 6종 예시 그리드',

  // ── Onboarding (구독 결제 후) ──
  obWelcomeTitle: '환영합니다!',
  obWelcomeSubtitle: '내일 아침부터 매일 받아볼 brief 를 위해 몇 가지만 알려주세요. 약 1분 걸려요.',
  obStep1Title: '도시와 발송 시간',
  obStep1Subtitle: '어디 날씨를 기준으로, 몇 시에 보내드릴까요?',
  obLabelCity: '도시',
  obCityPlaceholder: '천안, 서울, Seoul, ...',
  obLabelHour: '발송 시간 (현지)',
  // 도시 검색/위치 감지 (CityPicker)
  cityHint: '도시명을 입력하면 후보가 나타납니다. 정확한 날씨를 위해 목록에서 선택하거나 “내 위치로 찾기” 를 눌러주세요.',
  citySearching: '검색 중…',
  cityNoResults: '검색 결과가 없어요. 영문 도시명으로 입력하거나 “내 위치로 찾기” 를 사용해 보세요.',
  cityDetectBtn: '내 위치로 찾기',
  cityDetecting: '위치 확인 중…',
  cityDetectFail: '위치를 가져올 수 없어요. 도시명을 직접 입력해 주세요.',
  cityDetectDenied: '위치 권한이 거부됐어요. 브라우저에서 허용하거나 도시명을 입력해 주세요.',
  obStep2Title: '사진',
  obStep2Subtitle: '하루 한 번 사용되고 안전하게 저장됩니다. 정면 전신 또는 상반신 사진.',
  obStep3Title: '신체 정보',
  obStep3Subtitle: '정확할수록 추천이 맞아 떨어집니다.',
  obStep4Title: '준비 완료!',
  obStep4Subtitle: '내일 아침 {time} 에 첫 brief 가 도착합니다. 첫 미리보기는 지금 자동으로 보내드릴게요.',
  obBtnPreviewSending: '미리보기 발송 중...',
  obPreviewSending: '미리보기 brief 생성·발송 중... (20-30초 소요)',
  obPreviewLoadingTitle: '오늘의 Aura Daily 를 준비하고 있어요',
  obPreviewSteps: [
    '사진을 분석하는 중…',
    '오늘 날씨를 확인하는 중…',
    '오늘의 코디를 구성하는 중…',
    '착장 이미지를 만드는 중…',
    '메일로 보낼 brief 를 다듬는 중…',
  ],
  obPreviewRain: '강수',
  obPreviewImageAlt: '오늘의 코디 미리보기',
  obPreviewSent: '✓ 미리보기 brief 를 메일로 보냈어요. 아래에서 바로 확인하세요.',
  obPreviewFail: (msg) => `미리보기 발송 실패: ${msg}`,
  obBtnPreviewRetry: '다시 시도',
  obBtnClose: '닫기',
  obBtnGoHome: '메인으로',
  obBtnNext: '다음',
  obBtnPrev: '이전',
  obBtnFinish: '시작하기',
  obBtnSkipPreview: '나중에',
  obSaving: '저장 중...',
  obSaveFail: (msg) => `저장 실패: ${msg}`,
  obProgress: (step, total) => `${step} / ${total} 단계`,

  // ── 마이페이지 구독 섹션 ──
  mySubTitle: '구독',
  mySubNone: '활성 구독이 없어요.',
  mySubStartCta: 'Aura Daily 시작하기',
  mySubStatusTrialing: '무료 체험 중',
  mySubStatusActive: '활성',
  mySubStatusPastDue: '결제 실패',
  mySubStatusCanceled: '취소됨',
  mySubStatusPaused: '일시정지',
  mySubTrialEnds: '체험 종료',
  mySubNextBilling: '다음 결제',
  mySubCanceledNote: '현재 기간 종료일까지 사용 가능합니다.',
  mySubPaused: (until) => `${until} 까지 발송 중지됨`,
  mySubPauseCta: '일주일 일시정지',
  mySubResumeCta: '발송 재개',
  mySubCancelCta: '구독 취소',
  mySubCancelConfirm: '정말 취소하시겠어요? 현재 기간 끝날 때까지는 계속 받으실 수 있어요.',
  mySubCancelConfirmTrial: '트라이얼 중 취소하시면 즉시 발송이 중단되고 남은 무료 기간을 사용할 수 없습니다. 정말 취소하시겠어요?',
  mySubActionSaving: '처리 중...',
  mySubActionFail: (msg) => `실패: ${msg}`,
  mySubManageCta: '구독·결제 관리 (Polar)',
  mySubManageOpening: '포털 여는 중...',
  mySubManageHint: '결제수단·인보이스·해지·재개를 Polar 포털에서 처리할 수 있습니다. 가입 이메일로 일회용 코드를 받아 사인인합니다.',

  // ── 퍼스널 컬러 팔레트 (스타일 리포트 결과 페이지) ──
  pcPaletteTitle: '퍼스널 컬러 팔레트',
  pcPaletteBest: '베스트 컬러',
  pcPaletteAvoid: '피해야 할 컬러',
  pcSkinTone: '대표 피부색',
  pcSummary: '퍼스널 컬러 요약',

  // ── 프로필 정보 (MyPage > 사진·신체정보) ──
  profileSection: '프로필 정보',
  profileHint: '사진과 신체 정보. cron 이 매일 brief 생성 시 활용합니다.',
  profilePhoto: '사진',
  profilePhotoUploaded: (date) => `✓ 등록됨 (${date})`,
  profilePhotoUploadedNoDate: '✓ 등록됨',
  profilePhotoNone: '사진이 등록되지 않았어요. 일일 brief 발송에 필요합니다.',
  profilePhotoChange: '사진 변경',
  profilePhotoUpload: '사진 업로드',
  profilePhotoUploading: '업로드 중...',
  profilePhotoUpdated: '사진이 업데이트되었어요.',
  profileSave: '신체 정보 저장',
  profileSaving: '저장 중...',
  profileSaved: '프로필 정보가 저장되었어요.',
  profileSaveFail: (msg) => `저장 실패: ${msg}`,

  // ── 발송 환경설정 (MyPage > Delivery preferences) ──
  dpSection: '발송 환경설정',
  dpHint: '데일리 brief 를 받을 이메일·시간·도시를 관리합니다.',
  dpEmail: '받는 이메일',
  dpEmailPlaceholder: '비워두면 가입 이메일로 발송',
  dpEmailUseAccount: (e) => `가입 이메일로 (${e})`,
  dpEmailUsePolar: (e) => `Polar 결제 이메일로 (${e})`,
  dpEmailDiffersWarning: '⚠ 가입 이메일과 다릅니다. 비밀번호 재설정 등 계정 메일은 가입 이메일로만 발송됩니다.',
  dpEmailInvalid: '올바른 이메일 형식이 아닙니다.',
  dpCity: '도시',
  dpCityPlaceholder: '예: Seoul',
  dpTimezone: '타임존',
  dpTimezoneAutoDetect: '내 위치 감지',
  dpTimezoneHint: (tz, h) => `현지 시각 기준 매일 ${String(h).padStart(2,'0')}:00 에 발송됩니다 (${tz}).`,
  dpDeliveryHour: '발송 시각 (현지)',
  dpLanguage: '언어',
  dpLanguageKo: '한국어',
  dpLanguageEn: 'English',
  dpSave: '저장',
  dpSaving: '저장 중...',
  dpSaved: '발송 환경설정이 저장되었어요.',
  dpSaveFail: (msg) => `저장 실패: ${msg}`,
  dpNotOnboarded: '온보딩이 완료되지 않았어요. 메인 화면에서 마저 등록해 주세요.',

  pageTitle: 'AI 퍼스널 스타일리스트 — 1분 맞춤 스타일 컨설팅',
  pageSubtitle: '사진과 신체 정보를 입력하면 AI가 체형 분석, 퍼스널 컬러, 코디 팁, 추천 헤어스타일 6종까지 약 1분 만에 분석해드립니다.',

  featureLabel: '서비스 특징',
  feature1Title: '약 1분 결과',
  feature1Desc: '결제 후 약 1분 안에 텍스트 리포트와 헤어스타일 이미지를 모두 받습니다.',
  feature2Title: '본인 사진만 · 18세 이상',
  feature2Desc: '업로드한 사진은 서버에 저장되지 않으며, 만 18세 이상만 이용 가능합니다.',
  feature3Title: 'OpenAI 기반 분석',
  feature3Desc: '최신 OpenAI 모델로 체형·컬러·스타일을 종합 분석한 맞춤 리포트를 제공합니다.',
  feature4Title: '실패 시 자동 환불',
  feature4Desc: 'AI 생성 실패 시 결제 금액 전액이 자동으로 환불됩니다.',

  howtoLabel: '이용 방법',
  howtoTitle: '이용 방법은 단 3단계',
  step1Title: '사진과 정보 입력',
  step1Desc: '본인 정면 사진과 키·몸무게·체형 정보를 입력합니다. 자세한 신체 정보일수록 더 정확한 리포트가 생성됩니다.',
  step2Title: '결제 (1회 6.99 USD)',
  step2Desc: '이용약관에 동의한 뒤 결제 페이지로 이동합니다. 카드 결제는 Polar의 보안 환경에서 처리되며 자동 갱신이 없습니다.',
  step3Title: '1분 후 결과 수령',
  step3Desc: '결제가 완료되면 자동으로 분석이 시작되어 약 1분 안에 맞춤 리포트와 헤어스타일 6종 이미지를 받아볼 수 있습니다.',

  cardPhoto: '사진 업로드',
  cardBasic: '기본 정보',
  cardDetail: '상세 체형',
  cardBody: '체형 선택',
  cardConsent: '이용 동의',

  labelGender: '성별',
  labelHeight: '키 (cm)',
  labelHeightFt: '키 (ft·in)',
  labelHeightFeet: 'ft',
  labelHeightInches: 'in',
  labelWeight: '몸무게 (kg)',
  labelWeightLb: '몸무게 (lb)',
  labelLeg: '다리길이',
  labelShoulder: '어깨너비',
  labelUnits: '단위',
  unitMetric: 'cm · kg',
  unitImperial: 'ft · lb',
  placeholderHeight: '175',
  placeholderWeight: '70',
  placeholderFeet: '5',
  placeholderInches: '9',
  placeholderLb: '155',

  dropzoneClick: '클릭하여 사진 선택',
  dropzoneHere: '여기에 놓아주세요',
  dropzoneHint: '또는 여기로 사진을 드래그하세요',
  photoRemove: '삭제',
  photoTip1: '정면 사진 권장 · 전신 또는 상반신 · 밝은 곳에서 촬영',
  photoTip2Pre: '',
  photoTip2Strong: '본인 사진만',
  photoTip2Post: ' 업로드 가능 (만 18세 이상)',
  photoTip3: '업로드 사진은 분석 전 자동으로 압축됩니다 (원본 최대 50MB 지원)',
  photoTip4: '업로드 사진은 분석 후 서버에 저장되지 않습니다',

  consent1Pre: '저는 만 ',
  consent1Strong: '18세 이상',
  consent1Mid: '이며, ',
  consent1Terms: '이용약관',
  consent1And: '과 ',
  consent1Privacy: '개인정보 처리방침',
  consent1Post: '에 동의합니다.',
  consent2Pre: '업로드한 사진은 ',
  consent2Strong: '본인 사진',
  consent2Mid: '이며, 페이스 스왑·딥페이크·타인 사칭에 사용하지 않겠습니다.',
  consent2More: '자세한 내용은 ',
  consent2AUP: '서비스 이용 정책',
  consent2Post: '에서 확인할 수 있습니다.',

  legalNote1: '본 서비스의 결과는 ',
  legalNote1Strong: '패션·미용 분야의 참고용 추천',
  legalNote1Post: '이며, 의료·건강·다이어트 자문이 아닙니다. 건강 관련 결정은 자격 있는 전문가와 상담하세요.',
  legalNote2Pre: '"결제하고 AI 스타일 리포트 받기" 버튼을 누르면 보안 결제 페이지(Polar)로 이동합니다. 결제가 완료되면 자동으로 분석이 시작됩니다. 결제 전 ',
  legalNote2Link: '환불 정책',
  legalNote2Post: '을 꼭 확인해 주세요. AI 생성이 실패하면 전액 자동 환불됩니다.',

  ctaButton: '결제하고 AI 스타일 리포트 받기',
  ctaRedirecting: '결제 페이지로 이동 중...',

  errorPhoto: '사진을 업로드해 주세요.',
  errorGender: '성별을 선택해 주세요.',
  errorHeightWeight: '키와 몸무게를 모두 입력해 주세요.',
  errorLeg: '다리길이를 선택해 주세요.',
  errorShoulder: '어깨너비를 선택해 주세요.',
  errorBody: '체형을 선택해 주세요.',
  errorConsent: '이용약관에 동의해 주세요. 만 18세 이상이며 본인 사진임을 확인해야 합니다.',
  errorFileType: '이미지 파일만 업로드할 수 있습니다.',
  errorFileSize: '파일 크기가 50MB를 초과합니다. 더 작은 사진을 사용해 주세요.',
  errorCheckoutNoData: '결제 정보를 확인했지만 입력 데이터를 찾을 수 없습니다. 다시 입력해 주세요. (인앱 브라우저에서 결제하신 경우 일반 브라우저로 다시 시도해 보세요.)',
  errorStorageFull: '브라우저 저장 공간이 부족하거나 차단되어 있습니다. 시크릿 모드를 해제하거나 다른 브라우저로 시도해 주세요.',
  errorRequest: (status) => `요청 실패 (${status})`,
  refundAutoOk: ' ✅ 결제 금액은 자동으로 환불 처리되었습니다 (영업일 3~5일 내 입금).',
  refundAutoFail: (err) => ` ⚠️ 자동 환불에 실패했습니다 (${err}). 운영자에게 문의해 주세요.`,
  errorUnknown: '알 수 없는 오류가 발생했습니다.',
  errorCheckoutCreate: (status) => `결제 페이지 생성 실패 (${status})`,
  errorCheckoutRedirect: '결제 페이지로 이동하지 못했습니다.',
  errorReportEmpty: '보고서 내용을 받지 못했습니다.',

  faqLabel: '자주 묻는 질문',
  faqTitle: '자주 묻는 질문',
  faqQ1: 'AI 퍼스널 스타일리스트는 어떤 서비스인가요?',
  faqA1: '사진 한 장과 키·몸무게·체형 정보를 입력하면 AI가 약 1분 만에 체형 분석, 퍼스널 컬러, 어울리는 스타일·코디 팁, 피해야 할 스타일, 추천 헤어스타일 6종을 담은 맞춤 리포트를 제공하는 디지털 컨설팅 서비스입니다.',
  faqQ2: '이용 가격은 얼마인가요?',
  faqA2: '1회 6.99 USD (약 9,900원 상당)로 한 번 결제하면 맞춤 스타일 리포트와 헤어스타일 6종 이미지 한 세트를 받을 수 있습니다. 구독이 아닌 1회성 결제이며 자동 갱신이 없습니다.',
  faqQ3: '결과를 받는 데 얼마나 걸리나요?',
  faqA3: '결제 완료 후 약 1분 안에 보고서와 헤어스타일 이미지가 자동으로 생성되어 화면에 표시됩니다. 헤어스타일 이미지 생성에 따라 최대 2분이 걸릴 수 있습니다.',
  faqQ4: '업로드한 사진은 어떻게 처리되나요?',
  faqA4: '사진은 분석에 필요한 시간 동안만 사용되고 서버에 영구 저장되지 않습니다. OpenAI 외 어떠한 제3자에게도 사진이나 신체 정보가 공유·판매되지 않습니다. 자세한 내용은 푸터의 개인정보 처리방침에서 확인하실 수 있습니다.',
  faqQ5: '헤어스타일 이미지는 얼굴이 바뀌나요?',
  faqA5: '아니요. 본 서비스는 원본 얼굴을 그대로 유지하면서 헤어스타일만 변경하도록 설계되어 있습니다. 페이스 스왑·딥페이크·신원 합성은 제공하지 않으며, 약관에서도 금지하고 있습니다.',
  faqQ6: '미성년자도 이용할 수 있나요?',
  faqA6: '아니요. 본 서비스는 만 18세 이상만 이용할 수 있으며, 결제 전 연령 확인 체크박스에 동의해야 진행됩니다. 미성년자를 대상으로 마케팅하거나 서비스를 제공하지 않습니다.',
  faqQ7: 'AI가 분석에 실패하면 어떻게 되나요?',
  faqA7: '기술적 오류로 텍스트 리포트 또는 헤어스타일 이미지 중 어느 하나라도 생성에 실패하면 결제 금액 전액이 자동으로 환불됩니다. 환불은 결제하신 카드로 영업일 기준 3~5일 이내에 입금됩니다.',
  faqQ8: '본인이 아닌 다른 사람의 사진을 올려도 되나요?',
  faqA8: '안 됩니다. 본 서비스는 본인 사진만 업로드 가능하며, 타인의 사진(친구·연예인·무단 수집 이미지 포함)을 업로드하는 것은 약관 위반입니다. 위반 시 사전 통지 없이 이용이 차단될 수 있습니다.',

  loadingTitle: 'AI가 스타일을 분석하고 있어요.',
  loadingSubtitle: '체형, 비율, 분위기, 어울리는 코디를 종합 분석 중입니다.',
  loadingCaption: '보통 30초 ~ 1분 정도 소요됩니다',
  loaderSteps: ['사진 특징 분석 중', '체형과 비율 확인 중', '어울리는 스타일 매칭 중', '맞춤 리포트 생성 중'],

  resultChip: '분석 완료',
  resultTitle: '당신에게 어울리는 스타일 리포트.',
  resultSubtitle: '입력하신 데이터를 기반으로 AI가 분석한 맞춤형 스타일 컨설팅 결과입니다.',
  resultLegal: '본 리포트는 패션·미용 참고용입니다. 의료·건강·다이어트 자문이 아니며, 건강 관련 결정은 전문가와 상담하세요.',
  hairstyleHead: '추천 헤어스타일',
  hairstyleLoadingTitle: '추천 헤어스타일을 생성하고 있어요',
  hairstyleLoadingSubtitle: '약 1~2분이 소요됩니다. 페이지를 닫지 말고 잠시만 기다려 주세요.',
  hairstyleDownload: '이미지 다운로드',
  hairstyleAlt: '추천 헤어스타일 6가지',
  hairstyleError: (err) => `헤어스타일 이미지 생성 실패: ${err}`,
  sectionPrefix: 'SECTION',
  emailSentStrong: '이메일로도 발송되었습니다.',
  emailSentSuffix: '수신함에 도착하지 않았다면 스팸함을 확인해 주세요.',
  emailFailPrefix: '이메일 전송에 실패했습니다',
  emailFailSuffix: '. 화면의 리포트는 정상이며, 필요 시 "리포트 이미지로 저장" 버튼을 사용해 주세요.',
  btnSaveImage: '리포트 이미지로 저장',
  btnGenerating: '이미지 생성 중...',
  btnShare: '공유하기',
  btnRetry: '다시 분석하기',
  btnSaveHairstyle: '헤어스타일만 저장',
  shareTitle: 'AI 퍼스널 스타일 리포트',
  shareText: '나만의 AI 스타일 분석 결과를 받아봤어요!',
  imgSaveFail: (err) => `이미지 저장 실패: ${err}`,
  imgSavedToApp: '이미지를 갤러리에 저장하고 있어요. 저장 권한을 허용해 주세요.',
  shareFailUnsupportedWithCopy: '이 브라우저는 공유 기능을 지원하지 않아 사이트 링크를 클립보드에 복사했습니다.',
  shareFailUnsupported: '이 브라우저는 공유 기능을 지원하지 않습니다.',
  shareFail: (err) => `공유 실패: ${err}`,

  footerCopy: '© 2026 AI 퍼스널 스타일리스트. 만 18세 이상만 이용 가능.',
  linkTerms: '이용약관',
  linkRefund: '환불 정책',
  linkPrivacy: '개인정보 처리방침',
  linkAUP: '이용 정책',
};

const EN = {
  htmlLang: 'en',
  docTitle: 'AI Personal Stylist | Custom Style Report in 1 Minute',
  appTitle: 'AI Personal Stylist',
  back: 'Back',
  close: 'Close',
  langSwitcher: 'Language',

  // ── Auth ──
  authLogin: 'Log in',
  authLogout: 'Log out',
  authSignup: 'Sign up',
  authModalLoginTitle: 'Log in',
  authModalSignupTitle: 'Sign up',
  authEmail: 'Email',
  authPassword: 'Password',
  authPasswordPlaceholder: '6+ characters',
  authSubmitLogin: 'Log in',
  authSubmitSignup: 'Sign up',
  authSwitchToSignup: "Don't have an account? Sign up",
  authSwitchToLogin: 'Already have an account? Log in',
  authGoogle: 'Continue with Google',
  authOrDivider: 'or',
  authSignupSuccess: 'Confirmation email sent. Please check your inbox.',
  authSignupSuccessNoConfirm: 'Signed up and logged in.',
  authForgotPassword: 'Forgot your password?',
  authForgotPasswordSent: 'Reset link sent to your email.',
  authError: (msg) => `Error: ${msg}`,
  authAccountMenu: 'Account',
  authMyPage: 'My Page',

  // ── My Page ──
  myPageTitle: 'My Page',
  myPageInfoSection: 'My Info',
  myPageEmail: 'Email',
  myPageProvider: 'Sign-in method',
  myPageProviderEmail: 'Email',
  myPageProviderGoogle: 'Google',
  myPageJoined: 'Joined',
  myPageDisplayName: 'Display name',
  myPageDisplayNamePlaceholder: 'Name shown publicly',
  myPageSaveName: 'Save',
  myPageNameSaved: 'Saved.',

  myPagePasswordSection: 'Reset password',
  myPageNewPassword: 'New password',
  myPageNewPasswordPlaceholder: '6+ characters',
  myPageConfirmPassword: 'Confirm password',
  myPagePasswordSubmit: 'Update',
  myPagePasswordMismatch: 'Passwords do not match.',
  myPagePasswordTooShort: 'Password must be at least 6 characters.',
  myPagePasswordChanged: 'Password updated.',
  myPagePasswordNotForOAuth: 'Password change is not available for social-login accounts. Please manage your password from the social provider.',

  myPageDangerSection: 'Delete account',
  myPageDeleteWarning: 'Deleting your account will permanently remove all related data and cannot be undone.',
  myPageDeleteConfirmLabel: 'Type your email to confirm',
  myPageDeleteBtn: 'Delete my account permanently',
  myPageDeleting: 'Deleting...',
  myPageDeleteEmailMismatch: 'Email does not match.',
  myPageDeleteFail: (err) => `Delete failed: ${err}`,
  myPageBack: 'Back',
  myPageDeleteSuccess: "You've been signed out and your account removed. We hope to see you again.",

  pwRecoveryTitle: 'Set a new password',
  pwRecoverySubtitle: 'Choose a strong password. You will stay signed in after the update.',
  pwRecoverySaved: 'Password updated.',
  pwRecoveryCancel: 'Cancel and sign out',

  // ── Aura Daily subscription CTA ──
  subBadge: 'AURA DAILY',
  subTitle: "Wake up dressed — your outfit, every morning",
  subSubtitle: "An AI stylist sends one complete look every morning, matched to today's weather and your style profile. 7 days free. Cancel anytime.",
  subBullet1: 'One complete outfit + a Plan B daily',
  subBullet2: "Auto-tuned to your city's weather",
  subBullet3: 'A full-look lookbook on Sundays',
  subPriceMonthly: '$9.99 / month',
  subPriceUnit: 'about $0.33 a day',
  subPriceTrialBadge: 'after 7-day free trial',
  subCta: 'Start 7-day free trial',
  subCtaBusy: 'Redirecting to checkout...',
  subChipsLabel: 'Subscription safeguards',
  subChip1: '7 days free',
  subChip2: 'Cancel anytime',
  subChip3: 'No charge today',
  subTrustLine: 'Card required. You will not be charged until day 8 — reminder email 48 hours before.',
  subSubscribedToastTitle: 'Subscription started',
  subSubscribedToast: "Welcome — your first brief arrives tomorrow morning.",
  subErrorNeedLogin: 'Please log in to start your subscription.',

  // ── Landing hero ──
  heroEyebrow: 'AI PERSONAL STYLING',
  heroTitle: 'Never wonder what to wear again',
  heroSubtitle: 'One photo is all it takes. Get a daily outfit in your inbox, or a one-time in-depth style report — start whichever way you like.',
  heroCtaSub: 'Daily outfits · 7-day free trial',
  heroCtaReport: 'One-time report · $6.99',
  heroVisualAlt: 'AI personal stylist delivering today’s outfit',
  heroVisualCaption: 'Today’s mood',
  heroBadge: '7-day free trial · cancel anytime · no charge today',

  // ── Subscription showcase ──
  subShowTag: 'AURA DAILY · SUBSCRIPTION',
  subShowTitle: 'Every morning, today’s outfit in your inbox',
  subShowDesc: 'An AI that learns your city’s weather, your body type, and your taste sends one complete outfit with a try-on image every morning. Just wear it and go.',
  subShowPoint1: 'Tuned to today’s full-day weather',
  subShowPoint2: 'See it at a glance with a real try-on image',
  subShowPoint3: 'A weekend lookbook, too',
  subShowCta: 'Start 7-day free trial',
  subShowMockKicker: 'AURA DAILY',
  subShowMockDate: 'Friday, May 30',
  subShowMockWeather: '21°–29°C · Clear · 0% rain',
  subShowMockLine1: 'A light beige setup with a crisp white inner today.',
  subShowMockLine2: 'Strong sun — go for a breezy linen fabric.',
  subShowMockImageAlt: 'Example of one complete outfit for the day',

  // ── One-time report showcase ──
  repShowTag: 'ONE-TIME · REPORT',
  repShowTitle: 'One precise style diagnosis',
  repShowDesc: 'Body-type analysis, personal color, styles to embrace and avoid, plus 6 recommended hairstyle images. For $6.99 once, get a style guide you’ll reference for years.',
  repShowPoint1: 'Personal color & body-type analysis',
  repShowPoint2: '6 recommended hairstyle images',
  repShowPoint3: 'Not a subscription · no auto-renewal',
  repShowCta: 'Start one-time analysis',
  repShowMockKicker: 'STYLE REPORT',
  repShowMockColor: 'Personal color · Autumn warm muted',
  repShowMockBody: 'Body · Balanced straight',
  repShowMockHair: '6 recommended hairstyles',
  repShowMockHairAlt: 'Example grid of 6 recommended hairstyles',

  // ── Onboarding (post-subscribe) ──
  obWelcomeTitle: 'Welcome aboard!',
  obWelcomeSubtitle: 'A quick 1-minute setup so we can craft your brief for tomorrow morning.',
  obStep1Title: 'City and time',
  obStep1Subtitle: 'Which city for weather, and what time should the brief arrive?',
  obLabelCity: 'City',
  obCityPlaceholder: 'Seoul, New York, ...',
  obLabelHour: 'Delivery time (local)',
  // City search / location detect (CityPicker)
  cityHint: 'Type a city to see matches. Pick one from the list for accurate weather, or tap “Use my location”.',
  citySearching: 'Searching…',
  cityNoResults: 'No matches. Try an English city name or use “Use my location”.',
  cityDetectBtn: 'Use my location',
  cityDetecting: 'Locating…',
  cityDetectFail: "Couldn't get your location. Please type a city name.",
  cityDetectDenied: 'Location permission denied. Allow it in your browser or type a city name.',
  obStep2Title: 'Your photo',
  obStep2Subtitle: 'Used once per day and stored securely. Front-facing, full or upper body.',
  obStep3Title: 'Body info',
  obStep3Subtitle: 'More accurate input = better recommendations.',
  obStep4Title: "You're set!",
  obStep4Subtitle: "Your first brief will arrive tomorrow at {time}. We're sending your first preview right now.",
  obBtnPreviewSending: 'Sending preview...',
  obPreviewSending: 'Generating and sending your preview brief… (20–30 seconds)',
  obPreviewLoadingTitle: 'Preparing your Aura Daily',
  obPreviewSteps: [
    'Analyzing your photo…',
    "Checking today's weather…",
    "Composing today's outfit…",
    'Rendering your outfit image…',
    'Finalizing your brief…',
  ],
  obPreviewRain: 'rain',
  obPreviewImageAlt: "Today's outfit preview",
  obPreviewSent: '✓ Preview brief sent to your inbox. Here it is:',
  obPreviewFail: (msg) => `Preview send failed: ${msg}`,
  obBtnPreviewRetry: 'Try again',
  obBtnClose: 'Close',
  obBtnGoHome: 'Go to home',
  obBtnNext: 'Next',
  obBtnPrev: 'Back',
  obBtnFinish: 'Finish',
  obBtnSkipPreview: 'Later',
  obSaving: 'Saving...',
  obSaveFail: (msg) => `Save failed: ${msg}`,
  obProgress: (step, total) => `Step ${step} of ${total}`,

  // ── My Page subscription section ──
  mySubTitle: 'Subscription',
  mySubNone: 'No active subscription.',
  mySubStartCta: 'Start Aura Daily',
  mySubStatusTrialing: 'Free trial',
  mySubStatusActive: 'Active',
  mySubStatusPastDue: 'Payment failed',
  mySubStatusCanceled: 'Canceled',
  mySubStatusPaused: 'Paused',
  mySubTrialEnds: 'Trial ends',
  mySubNextBilling: 'Next billing',
  mySubCanceledNote: "You'll keep receiving briefs through the end of the current period.",
  mySubPaused: (until) => `Paused until ${until}`,
  mySubPauseCta: 'Pause for a week',
  mySubResumeCta: 'Resume delivery',
  mySubCancelCta: 'Cancel subscription',
  mySubCancelConfirm: "Are you sure? You'll keep receiving briefs until the current period ends.",
  mySubCancelConfirmTrial: 'Cancelling during the trial ends delivery immediately — you will lose the remaining free days. Continue?',
  mySubActionSaving: 'Processing...',
  mySubActionFail: (msg) => `Failed: ${msg}`,
  mySubManageCta: 'Manage subscription & billing (Polar)',
  mySubManageOpening: 'Opening portal...',
  mySubManageHint: 'Update payment method, download invoices, cancel or resume — all from the Polar customer portal. Sign in with a one-time code sent to your subscription email.',

  // ── Personal color palette (style report result page) ──
  pcPaletteTitle: 'Your color palette',
  pcPaletteBest: 'Best colors',
  pcPaletteAvoid: 'Colors to avoid',
  pcSkinTone: 'Representative skin tone',
  pcSummary: 'Personal color summary',

  // ── Profile (MyPage > photo + body info) ──
  profileSection: 'Profile',
  profileHint: 'Your photo and body info. Used by the daily brief generator.',
  profilePhoto: 'Photo',
  profilePhotoUploaded: (date) => `✓ Uploaded ${date}`,
  profilePhotoUploadedNoDate: '✓ Uploaded',
  profilePhotoNone: 'No photo on file. A photo is required for daily briefs.',
  profilePhotoChange: 'Change photo',
  profilePhotoUpload: 'Upload photo',
  profilePhotoUploading: 'Uploading...',
  profilePhotoUpdated: 'Photo updated.',
  profileSave: 'Save body info',
  profileSaving: 'Saving...',
  profileSaved: 'Profile saved.',
  profileSaveFail: (msg) => `Save failed: ${msg}`,

  // ── Delivery preferences (MyPage > Delivery preferences) ──
  dpSection: 'Delivery preferences',
  dpHint: 'Manage the email, time, and city your daily brief is delivered to.',
  dpEmail: 'Delivery email',
  dpEmailPlaceholder: 'Leave blank to use your account email',
  dpEmailUseAccount: (e) => `Use account email (${e})`,
  dpEmailUsePolar: (e) => `Use Polar checkout email (${e})`,
  dpEmailDiffersWarning: '⚠ This differs from your account email. Account emails (password reset etc.) are always sent to your account email.',
  dpEmailInvalid: 'Not a valid email address.',
  dpCity: 'City',
  dpCityPlaceholder: 'e.g. Seoul',
  dpTimezone: 'Timezone',
  dpTimezoneAutoDetect: 'Detect from device',
  dpTimezoneHint: (tz, h) => `Delivered daily at ${String(h).padStart(2,'0')}:00 local time (${tz}).`,
  dpDeliveryHour: 'Delivery time (local)',
  dpLanguage: 'Language',
  dpLanguageKo: '한국어',
  dpLanguageEn: 'English',
  dpSave: 'Save',
  dpSaving: 'Saving...',
  dpSaved: 'Delivery preferences saved.',
  dpSaveFail: (msg) => `Save failed: ${msg}`,
  dpNotOnboarded: 'Onboarding not finished yet. Please complete it from the home screen first.',

  pageTitle: 'AI Personal Stylist — 1-Minute Custom Style Consulting',
  pageSubtitle: 'Upload a photo and enter your body info — our AI will analyze body type, personal color, coordination tips, and 6 recommended hairstyles in about a minute.',

  featureLabel: 'Features',
  feature1Title: 'Results in ~1 Minute',
  feature1Desc: 'Receive both the text report and hairstyle images within about a minute after payment.',
  feature2Title: 'Own Photo Only · 18+',
  feature2Desc: 'Uploaded photos are not stored on our servers. Available to users 18+ only.',
  feature3Title: 'Powered by OpenAI',
  feature3Desc: 'Latest OpenAI models analyze your body, color, and style for a personalized report.',
  feature4Title: 'Auto-Refund on Failure',
  feature4Desc: 'If AI generation fails, the full payment is automatically refunded.',

  howtoLabel: 'How It Works',
  howtoTitle: 'Just 3 Steps to Your Report',
  step1Title: 'Upload Photo & Info',
  step1Desc: 'Upload your front-facing photo and enter height, weight, and body type. More accurate input leads to a better report.',
  step2Title: 'Pay ($6.99 one-time)',
  step2Desc: 'Accept the terms and proceed to checkout. Card payment is handled securely by Polar — no auto-renewal.',
  step3Title: 'Receive Results in 1 Minute',
  step3Desc: 'After payment, analysis runs automatically and your personalized report + 9 hairstyle images arrive in about a minute.',

  cardPhoto: 'Upload Photo',
  cardBasic: 'Basic Info',
  cardDetail: 'Body Details',
  cardBody: 'Body Type',
  cardConsent: 'Agreement',

  labelGender: 'Gender',
  labelHeight: 'Height (cm)',
  labelHeightFt: 'Height (ft·in)',
  labelHeightFeet: 'ft',
  labelHeightInches: 'in',
  labelWeight: 'Weight (kg)',
  labelWeightLb: 'Weight (lb)',
  labelLeg: 'Leg Length',
  labelShoulder: 'Shoulder Width',
  labelUnits: 'Units',
  unitMetric: 'cm · kg',
  unitImperial: 'ft · lb',
  placeholderHeight: '175',
  placeholderWeight: '70',
  placeholderFeet: '5',
  placeholderInches: '9',
  placeholderLb: '155',

  dropzoneClick: 'Click to select a photo',
  dropzoneHere: 'Drop here',
  dropzoneHint: 'or drag a photo here',
  photoRemove: 'Remove',
  photoTip1: 'Front-facing recommended · Full or upper body · Bright lighting',
  photoTip2Pre: '',
  photoTip2Strong: 'Your own photo only',
  photoTip2Post: ' (must be 18+)',
  photoTip3: 'Photos are auto-compressed before analysis (up to 50MB raw supported)',
  photoTip4: 'Photos are not stored on servers after analysis',

  consent1Pre: 'I am ',
  consent1Strong: '18 or older',
  consent1Mid: ' and agree to the ',
  consent1Terms: 'Terms of Service',
  consent1And: ' and ',
  consent1Privacy: 'Privacy Policy',
  consent1Post: '.',
  consent2Pre: 'The uploaded photo is ',
  consent2Strong: 'my own',
  consent2Mid: ', and I will not use this service for face swap, deepfake, or impersonating others. ',
  consent2More: 'See the ',
  consent2AUP: 'Acceptable Use Policy',
  consent2Post: ' for details.',

  legalNote1: 'This report is ',
  legalNote1Strong: 'a fashion/beauty reference only',
  legalNote1Post: ' and is not medical, health, or diet advice. Consult a qualified professional for health-related decisions.',
  legalNote2Pre: 'Clicking "Pay & Get AI Style Report" takes you to the secure Polar checkout. Analysis starts automatically after payment. Please review the ',
  legalNote2Link: 'Refund Policy',
  legalNote2Post: ' before paying. If AI generation fails, you will receive a full automatic refund.',

  ctaButton: 'Pay & Get AI Style Report',
  ctaRedirecting: 'Redirecting to checkout...',

  errorPhoto: 'Please upload a photo.',
  errorGender: 'Please select your gender.',
  errorHeightWeight: 'Please enter both height and weight.',
  errorLeg: 'Please select leg length.',
  errorShoulder: 'Please select shoulder width.',
  errorBody: 'Please select body type.',
  errorConsent: 'Please accept the terms — you must be 18+ and confirm this is your own photo.',
  errorFileType: 'Only image files are allowed.',
  errorFileSize: 'File exceeds 50MB. Please use a smaller photo.',
  errorCheckoutNoData: 'Payment confirmed, but input data was not found. Please re-enter and try again. (If you paid from an in-app browser, please retry in a normal browser.)',
  errorStorageFull: 'Browser storage is full or blocked. Please disable private/incognito mode or try a different browser.',
  errorRequest: (status) => `Request failed (${status})`,
  refundAutoOk: ' ✅ Your payment has been automatically refunded (arrives in 3–5 business days).',
  refundAutoFail: (err) => ` ⚠️ Automatic refund failed (${err}). Please contact support.`,
  errorUnknown: 'An unknown error occurred.',
  errorCheckoutCreate: (status) => `Failed to create checkout (${status})`,
  errorCheckoutRedirect: 'Could not redirect to checkout.',
  errorReportEmpty: 'Did not receive the report contents.',

  faqLabel: 'FAQ',
  faqTitle: 'Frequently Asked Questions',
  faqQ1: 'What is the AI Personal Stylist?',
  faqA1: 'A digital consulting service that takes one photo plus your height/weight/body info and, in about a minute, returns a personalized report with body-type analysis, personal color, suitable styles & coordination tips, styles to avoid, and 6 recommended hairstyles.',
  faqQ2: 'How much does it cost?',
  faqA2: 'A one-time payment of 6.99 USD gets you one personalized style report plus a set of 9 hairstyle images. Not a subscription — no auto-renewal.',
  faqQ3: 'How long does it take?',
  faqA3: 'The report and hairstyle images appear on screen automatically within about a minute after payment. Image generation may take up to ~2 minutes.',
  faqQ4: 'How are uploaded photos handled?',
  faqA4: 'Photos are used only during analysis and are not stored long-term on our servers. Photos and body info are never shared or sold to any third party other than OpenAI for processing. See the Privacy Policy in the footer for full details.',
  faqQ5: 'Do hairstyle images change my face?',
  faqA5: 'No. The service is designed to preserve your original face while changing only the hairstyle. Face swap, deepfake, and identity synthesis are not offered and are explicitly prohibited.',
  faqQ6: 'Can minors use this service?',
  faqA6: 'No. The service is available to users 18+ only. You must check the age confirmation box before payment. We do not market to or serve minors.',
  faqQ7: 'What happens if AI analysis fails?',
  faqA7: 'If either the text report OR the hairstyle image fails to generate due to a technical error, the full payment is automatically refunded to your card within 3–5 business days.',
  faqQ8: 'Can I upload someone else\'s photo?',
  faqA8: 'No. Only your own photo may be uploaded. Photos of others (friends, celebrities, scraped images) violate the terms. Violations may result in immediate suspension without notice.',

  loadingTitle: 'AI is analyzing your style.',
  loadingSubtitle: 'Analyzing your body type, proportions, vibe, and coordination.',
  loadingCaption: 'Usually takes 30 seconds to 1 minute',
  loaderSteps: ['Analyzing photo features', 'Checking body type and proportions', 'Matching suitable styles', 'Generating personalized report'],

  resultChip: 'Analysis Complete',
  resultTitle: 'Your Personalized Style Report.',
  resultSubtitle: 'Personalized style consulting analyzed by AI based on your input.',
  resultLegal: 'This report is for fashion/beauty reference only. Not medical, health, or diet advice — consult a professional for health-related decisions.',
  hairstyleHead: 'Recommended Hairstyles',
  hairstyleLoadingTitle: 'Generating your recommended hairstyles',
  hairstyleLoadingSubtitle: 'This usually takes 1–2 minutes. Please don\'t close this page.',
  hairstyleDownload: 'Download Image',
  hairstyleAlt: '6 recommended hairstyles',
  hairstyleError: (err) => `Hairstyle image generation failed: ${err}`,
  sectionPrefix: 'SECTION',
  emailSentStrong: 'Also delivered to your email.',
  emailSentSuffix: 'If not in your inbox, please check the spam folder.',
  emailFailPrefix: 'Email delivery failed',
  emailFailSuffix: '. The on-screen report is intact — use "Save Report as Image" if needed.',
  btnSaveImage: 'Save Report as Image',
  btnGenerating: 'Generating image...',
  btnShare: 'Share',
  btnRetry: 'Analyze again',
  btnSaveHairstyle: 'Save hairstyle only',
  shareTitle: 'My AI Personal Style Report',
  shareText: 'I just received my personal AI style analysis!',
  imgSaveFail: (err) => `Image save failed: ${err}`,
  imgSavedToApp: 'Saving the image to your gallery. Please allow the save permission.',
  shareFailUnsupportedWithCopy: 'Sharing not supported in this browser — site link copied to clipboard instead.',
  shareFailUnsupported: 'Sharing is not supported in this browser.',
  shareFail: (err) => `Share failed: ${err}`,

  footerCopy: '© 2026 AI Personal Stylist. Available to users 18+ only.',
  linkTerms: 'Terms of Service',
  linkRefund: 'Refund Policy',
  linkPrivacy: 'Privacy Policy',
  linkAUP: 'Acceptable Use',
};

export const STRINGS = { ko: KO, en: EN };

export const GENDER_OPTIONS = {
  ko: [
    { value: 'male', label: '남성' },
    { value: 'female', label: '여성' },
  ],
  en: [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
  ],
};

export const LEG_LENGTH_OPTIONS = {
  ko: ['짧다', '약간 짧다', '보통', '약간 길다', '길다'],
  en: ['Short', 'Slightly short', 'Average', 'Slightly long', 'Long'],
};

export const SHOULDER_WIDTH_OPTIONS = {
  ko: ['좁다', '약간 좁다', '보통', '약간 넓다', '넓다'],
  en: ['Narrow', 'Slightly narrow', 'Average', 'Slightly wide', 'Wide'],
};

export const BODY_TYPE_OPTIONS = {
  ko: ['상체발달형', '하체발달형', '보통형', '잘모르겠음'],
  en: ['Upper-body dominant', 'Lower-body dominant', 'Average', 'Not sure'],
};

// ---------- 정책 본문 ----------

const POLICIES_KO = {
  terms: {
    title: '이용약관 (Terms of Service)',
    body: `**최종 수정일: 2026년 5월 26일**

**1. 서비스 개요**
본 서비스(이하 "서비스")는 AI 기술을 이용해 사용자가 업로드한 본인 사진과 체형 정보를 분석하여 패션·스타일·헤어스타일 추천을 제공하는 **1회성 디지털 컨설팅 서비스**입니다.

**2. 이용 자격**
- 만 18세 이상만 이용할 수 있습니다.
- 미성년자는 본 서비스를 이용할 수 없으며, 운영자는 미성년자를 대상으로 마케팅하거나 서비스를 제공하지 않습니다.
- 사용자는 결제 시 자신이 만 18세 이상임을 보증합니다.

**3. 결제 및 가격**
- 본 서비스의 이용 요금은 **1회 6.99 USD**이며, 1회 결제로 1회의 분석 결과(텍스트 리포트 + 헤어스타일 이미지 6종)를 제공합니다.
- **구독제가 아니며 자동 갱신되지 않습니다.** 결제는 1회로 종료됩니다.
- 결제는 **Polar Software Inc.("Polar")** 의 호스팅 체크아웃 페이지에서 처리되며, **카드 정보·결제 수단 상세는 본 서비스의 서버에 저장되지 않습니다.**
- 표시 통화는 USD이며, 원화 결제 시 카드사 환율과 해외 결제 수수료가 추가될 수 있습니다.
- Polar의 결제 약관은 https://polar.sh/legal/terms 에서 확인할 수 있습니다.

**4. 환불**
환불 조건과 절차는 별도의 **환불 정책(Refund Policy)** 을 따릅니다. 결제 전 환불 정책을 반드시 확인해 주세요. 주요 내용은 다음과 같습니다.
- AI 텍스트 리포트와 헤어스타일 이미지 중 **어느 하나라도 기술적으로 실패하면 전액이 자동으로 환불**됩니다.
- 분석 결과 리포트는 **결제 시 입력하신 이메일 주소로 자동 발송**되며, **이메일 주소를 잘못 입력하여 받지 못한 경우는 환불 대상이 아닙니다.**
- 결제일로부터 7일 이내 결과물에 명백한 결함이 있는 경우 수동 환불을 요청할 수 있습니다.
- AI 결과물의 주관적 만족도(단순히 마음에 들지 않음)는 환불 사유가 아닙니다.

**5. 사용자 의무**
- 본인의 사진만 업로드해야 하며, 타인의 사진(친구, 가족, 연예인, 무단 수집 이미지 포함)을 절대 업로드해서는 안 됩니다.
- 업로드한 사진에 대한 사용 권리는 사용자 본인에게 있어야 합니다.
- 입력하는 신체 정보는 본인의 실제 정보여야 하며, 허위 정보로 인한 결과 품질 저하는 환불 대상이 아닙니다.
- 다음 용도로 본 서비스를 사용할 수 없습니다:
  - 타인의 얼굴 변조, 페이스 스왑, 딥페이크 생성
  - 성인용·노출 콘텐츠 생성
  - 신원 사칭·기만
  - 무기·마약·도박·기타 위법 행위 홍보
  - 의료·건강·다이어트 조언 획득
  - 자동화된 대량 요청(스크래핑·크롤링) 또는 API 우회
- 자세한 금지 행위는 **서비스 이용 정책(Acceptable Use)** 을 참고하세요.

**6. 서비스 성격 및 면책**
- 본 서비스가 제공하는 결과물은 **패션·미용 분야의 참고용 추천**일 뿐이며, 의료·건강·영양·정신상담 등의 전문 자문이 아닙니다.
- 운영자는 AI 결과물의 정확성·완전성·적합성을 보증하지 않으며, 결과물에 의존한 결정으로 발생한 손해에 대해 책임지지 않습니다.
- 운영자의 손해배상 책임은 어떠한 경우에도 해당 사용자가 실제 지불한 금액(1회 6.99 USD)을 초과하지 않습니다.

**7. 결과물 권리**
- AI가 생성한 텍스트와 이미지의 권리는 OpenAI 등 모델 제공자의 약관(https://openai.com/policies)을 따르며, 일반적으로 사용자는 개인적·비상업적 용도로 사용할 수 있습니다.
- 사용자는 결과물을 타인을 속이거나 명예를 훼손하거나 위법한 목적으로 사용할 수 없습니다.

**8. 서비스 변경 및 종료**
- 운영자는 사전 통지 없이 서비스의 기능, 가격, 약관을 변경하거나 서비스를 중단할 수 있습니다.
- 본 약관 위반이 확인된 사용자는 사전 통지 없이 이용이 차단될 수 있으며, 이 경우 환불 의무는 발생하지 않습니다.

**9. 준거법 및 분쟁 해결**
- 본 약관은 **대한민국 법률**에 따라 해석됩니다.
- 본 약관 또는 서비스 이용과 관련한 분쟁은 사용자의 주소지를 관할하는 대한민국 법원을 1심 전속 관할로 합니다.

**10. 약관 변경**
변경된 약관은 본 페이지에 게시되는 시점부터 효력이 발생합니다. 변경 후 서비스를 계속 이용하는 것은 변경된 약관에 동의한 것으로 봅니다.

**11. 문의**
약관 관련 모든 문의는 **xchanheex@gmail.com** 으로 연락 부탁드립니다.`,
  },
  refund: {
    title: '환불 정책 (Refund Policy)',
    body: `**최종 수정일: 2026년 5월 26일**

본 서비스는 1회 결제로 1회의 AI 분석 결과를 제공하는 디지털 컨설팅 서비스입니다. 결제 즉시 자동으로 서비스가 제공되는 특성상, 다음 정책에 따라 환불을 처리합니다.

**1. 자동 환불 (Automatic Refund)**
다음의 기술적 실패가 발생한 경우, **별도 요청 없이 결제 금액 전액(6.99 USD)이 자동으로 환불됩니다.**
- AI 텍스트 리포트 생성이 실패한 경우
- AI 헤어스타일 이미지(6종) 생성이 실패한 경우
- OpenAI API 오류로 결과를 전송하지 못한 경우
- 서버 측 처리 중 5xx 오류가 발생한 경우

**텍스트 리포트와 헤어스타일 이미지 중 어느 하나라도 정상적으로 생성되지 않으면, 부분 제공 없이 결제 금액 전액이 환불됩니다.** 시스템이 결제 직후 Polar에 환불 요청을 자동 전송하며, 실제 카드 입금까지는 **영업일 기준 3~5일**이 소요됩니다.

**2. 리포트 이메일 전송 규정**
- 분석 결과 리포트는 **결제 시 Polar 체크아웃 페이지에서 입력하신 이메일 주소로 자동 발송**됩니다. 본 서비스에서 이메일 주소를 별도로 입력받지 않습니다.
- 화면에 표시되는 결과와 동일한 내용이 이메일로도 전달되며, 추천 헤어스타일 6종 이미지는 JPG 파일로 첨부됩니다.
- **결제 시 이메일 주소를 잘못 입력하여 리포트 이메일을 받지 못한 경우는 환불 대상이 아닙니다.** Polar 영수증이 정상 수신되는지 확인해 주세요. 영수증이 도착했다면 동일한 주소로 리포트가 발송됩니다.
- 이메일이 도착하지 않은 경우 먼저 **스팸함**을 확인해 주시고, 그래도 없다면 화면의 리포트는 그대로 보존되므로 "리포트 이미지로 저장" 버튼으로 직접 받으실 수 있습니다.

**3. 수동 환불 (Manual Refund)**
다음의 경우 **결제일로부터 7일 이내** 운영자 이메일로 요청하시면 검토 후 환불해드립니다.
- 리포트는 생성되었으나 결과물에 명백한 결함이 있는 경우 (예: 텍스트가 의미를 알 수 없을 정도로 깨짐, 헤어스타일 이미지가 완전히 다른 사람의 얼굴로 합성됨)
- 약관에 명시되지 않은 중대한 서비스 결함

요청 시 다음 정보를 함께 보내주세요.
- Polar 결제 영수증 또는 주문 ID (checkout_id / order_id)
- 결제 일자 및 결제 카드의 앞 4자리·뒷 4자리
- 환불을 요청하는 구체적인 사유와 (가능하다면) 결과물 스크린샷

운영자는 영업일 기준 **3일 이내** 검토 결과를 회신하며, 환불이 승인되면 Polar를 통해 즉시 처리됩니다.

**4. 환불이 불가한 경우**
- AI 리포트와 헤어스타일 이미지가 정상적으로 제공되었으나, 결과가 **단순히 마음에 들지 않는 경우**
- 사용자가 잘못된 사진(흐릿한 사진, 얼굴이 가려진 사진, 다른 사람의 사진 등)을 업로드한 경우
- 본인이 입력한 신체 정보가 사실과 달라 결과가 적절하지 않은 경우
- **결제 시 이메일 주소를 잘못 입력하여** 리포트 이메일을 받지 못한 경우
- **결제일로부터 7일이 경과한** 환불 요청
- 약관 위반(타인 사진 업로드, 18세 미만 사용, 페이스 스왑 시도 등)으로 이용이 차단된 경우

**5. 환불 처리 방식**
- 모든 환불은 **결제하신 원래 결제 수단(카드)** 으로 처리됩니다.
- 환불은 Polar의 결제 시스템을 통해 처리되며, 실제 입금 완료까지 카드사 정책에 따라 **영업일 기준 3~10일**이 소요될 수 있습니다.
- 해외 결제 수수료, 환율 차액은 카드사 정책에 따르며 보전되지 않습니다.

**6. 카드사 분쟁 (Chargeback)**
카드사 차지백을 제기하기 전에 먼저 운영자 이메일로 연락 부탁드립니다. 합리적인 환불 요청은 대부분 신속하게 처리해드립니다.

**7. 문의**
환불 관련 모든 문의는 **xchanheex@gmail.com** 으로 연락 부탁드립니다.`,
  },
  privacy: {
    title: '개인정보 처리방침 (Privacy Policy)',
    body: `**최종 수정일: 2026년 5월 26일**

**1. 수집하는 정보**

(가) 사용자가 직접 제공하는 정보
- 본인 사진 1장
- 키, 몸무게, 성별, 다리길이, 어깨너비, 체형 입력값
- 약관 동의 여부

(나) 결제 과정 — Polar에서 직접 수집
- 결제 카드 정보, 청구지 주소, 이메일
- 위 정보는 결제 처리자인 **Polar Software Inc.** 가 직접 수집·처리하며, **본 서비스 서버에는 카드 번호·결제 수단 상세가 저장되지 않습니다.**
- 본 서비스는 결제 검증·환불 처리를 위해 Polar로부터 결제 ID(checkout_id, order_id), 결제 금액, 결제 상태, 이메일 주소만 수신합니다.

(다) 자동 수집
- IP 주소(결제 부정 방지 목적으로 Polar에 전달)
- 접속 로그(Cloudflare 기본 로그)

**2. 처리 목적**
- AI 스타일 컨설팅 리포트·헤어스타일 이미지 생성
- 결제 검증·환불 처리
- 결과 리포트 이메일 발송
- 부정 사용 방지 및 법적 의무 준수

**3. 처리 흐름**
1. 사용자 브라우저에서 사진을 1280px 이하로 압축
2. HTTPS로 본 서비스의 엣지 서버(Cloudflare Pages Functions)에 전송
3. 서버가 OpenAI API에 데이터를 전달하여 결과 수신
4. 결과를 사용자 브라우저에 반환 + Polar에서 받은 이메일로 Resend를 통해 발송

**4. 위탁 및 제3자 제공**
- **OpenAI, L.L.C.** (미국) — AI 분석 / 사진·신체 정보 / https://openai.com/policies/privacy-policy
- **Polar Software Inc.** (미국) — 결제 처리·환불 / 결제 정보, 이메일, IP / https://polar.sh/legal/privacy
- **Cloudflare, Inc.** (글로벌) — 호스팅·엣지 / 접속 로그 / https://www.cloudflare.com/privacypolicy/
- **Resend, Inc.** (미국) — 결과 리포트 이메일 전송 / 수신자 이메일, 리포트 본문, 헤어스타일 이미지 / https://resend.com/legal/privacy-policy

그 외 어떠한 제3자에게도 **판매·공유·임대하지 않습니다.**

**5. 국외 이전**
본 서비스의 데이터 처리는 미국 및 글로벌 인프라에서 이루어지므로 데이터가 대한민국 외 국가로 이전될 수 있습니다. 본 서비스 이용 시 이러한 국외 이전에 동의한 것으로 봅니다.

**6. 보관 기간**
- **본 서비스 서버**: 장기 보관 없음. 일시 메모리에서 처리 후 폐기.
- **OpenAI**: 최대 30일(abuse-monitoring) 후 삭제.
- **Polar**: 결제 영수증·환불 기록은 세무·회계 법규에 따라 최대 5년.
- **Cloudflare**: 보안·운영 로그는 자체 정책에 따라 자동 만료.
- **Resend**: 발송 기록·이메일 로그는 자체 정책에 따라 일정 기간(현재 30일) 후 자동 삭제.

**7. 사용자의 권리**
- 개인정보 처리 현황 열람, 정정, 삭제, 처리 정지, 동의 철회 요청
- 사진·신체 정보는 서버에 저장되지 않으므로 별도 삭제 요청 절차가 필요하지 않습니다.
- 결제 기록 관련 요청은 운영자 이메일로 연락 부탁드립니다.

**8. 미성년자**
본 서비스는 만 18세 이상만 이용 가능하며, 만 14세 미만 아동의 정보를 의도적으로 수집하지 않습니다.

**9. 쿠키 및 로컬 저장소**
- 광고·트래커용 제3자 쿠키 미사용.
- 결제 진행 중 sessionStorage에 입력 데이터를 임시 보관하며, 분석 완료 시 삭제됩니다.
- Polar 결제 페이지에서는 자체 쿠키가 사용될 수 있습니다.

**10. 정보 보호 조치**
- 모든 통신은 HTTPS(TLS) 암호화.
- API 키 등 민감 정보는 환경 변수로 관리되며 클라이언트 코드에 포함되지 않습니다.
- 사진·신체 정보는 서버에 영구 저장되지 않습니다.

**11. 처리방침 변경**
본 방침은 변경 시 본 페이지 게시 시점부터 효력이 발생합니다.

**12. 문의**
모든 문의는 **xchanheex@gmail.com** 으로 연락 부탁드립니다.`,
  },
  aup: {
    title: '서비스 이용 정책 (Acceptable Use)',
    body: `사용자는 본 서비스에서 다음 행위를 절대 할 수 없습니다.

**금지되는 사용**
- 타인의 사진·얼굴·신체 이미지 업로드
- 페이스 스왑·딥페이크·신원 합성·연예인 합성 시도
- 성인 콘텐츠, 노출 사진, 미성년자 사진의 업로드
- 미성년자 사용자(만 18세 미만)의 이용
- 의료·진단·다이어트·정신상담 등 전문 자문 목적의 사용
- 운세·점성술·관상학적 예측 등 유사과학 자문 시도
- 무기, 마약, 도박, 폭력, 차별, 불법 상품·서비스 홍보
- 타인의 명예 훼손·괴롭힘·스토킹 목적의 결과물 활용
- 본 서비스 결과물을 통한 사기·기만·금융 유인
- 자동화된 대량 요청(스크래핑·크롤링) 또는 API 우회

**위반 조치**
정책 위반이 확인되면 사전 통지 없이 사용을 차단할 수 있으며, 필요한 경우 관련 기관에 신고할 수 있습니다.

**신고**
다른 사용자의 위반을 확인하신 경우 **xchanheex@gmail.com** 으로 신고 부탁드립니다.`,
  },
};

const POLICIES_EN = {
  terms: {
    title: 'Terms of Service',
    body: `**Last updated: May 26, 2026**

**1. Service Overview**
This service (the "Service") is a **one-time digital consulting service** that uses AI to analyze a photo of yourself and body information you provide, and returns fashion, style, and hairstyle recommendations.

**2. Eligibility**
- You must be 18 years of age or older to use the Service.
- Minors may not use the Service. The operator does not market to or knowingly serve minors.
- By paying for the Service you represent that you are 18 or older.

**3. Pricing & Payment**
- The Service costs **6.99 USD per single use** and delivers one analysis (text report plus 9 hairstyle images) per payment.
- **This is not a subscription — there is no auto-renewal.** Payment terminates after one charge.
- Payment is processed by **Polar Software Inc. ("Polar")** through their hosted checkout. **Card details and payment-method specifics are never stored on our servers.**
- Prices are displayed in USD. If your card is in another currency, your card issuer's exchange rate and foreign-transaction fees may apply.
- Polar's terms: https://polar.sh/legal/terms

**4. Refunds**
Refund conditions and procedures are governed by the separate **Refund Policy**. Please review it before purchasing. Key points:
- If **either** the text report **or** the hairstyle image fails to generate due to a technical error, **the full payment is automatically refunded.**
- The report is **automatically emailed to the address you entered at Polar checkout. If you mistyped the address and didn't receive it, no refund is issued** (the on-screen report remains intact).
- Manual refund requests for clear defects are accepted within **7 days of payment**.
- Subjective dissatisfaction with the AI output is not a valid refund reason.

**5. User Obligations**
- Upload only photos of yourself. Photos of others (friends, family, celebrities, scraped images) are strictly prohibited.
- You must own the rights to any photo you upload.
- Body information you provide must be accurate. Poor results caused by inaccurate input are not eligible for refund.
- You may not use the Service for:
  - Face manipulation, face swaps, or deepfakes of others
  - Generating adult/explicit content
  - Identity impersonation or deception
  - Promoting weapons, drugs, gambling, or other illegal activities
  - Seeking medical, health, or diet advice
  - Automated mass requests (scraping/crawling) or bypassing the API
- See the **Acceptable Use Policy** for the full list.

**6. Nature of the Service & Disclaimers**
- All output is **a fashion/beauty reference only** and is not professional medical, nutritional, mental-health, or other advice.
- The operator does not warrant the accuracy, completeness, or fitness of AI output and is not liable for direct, indirect, or consequential damages arising from reliance on it.
- The operator's total liability shall not exceed the amount actually paid by the affected user (6.99 USD per transaction).

**7. Output Rights**
- Rights to AI-generated text and images follow the relevant model provider's terms (e.g., https://openai.com/policies). Generally, you may use the output for personal, non-commercial purposes.
- You may not use the output to deceive, defame, or for any unlawful purpose.

**8. Service Changes & Termination**
- The operator may change features, pricing, or these Terms — or discontinue the Service — without prior notice.
- Users who violate these Terms may be suspended without notice, with no refund obligation.

**9. Governing Law & Disputes**
- These Terms are governed by the **laws of the Republic of Korea**.
- Any disputes shall be brought in the Korean court that has jurisdiction over the user's place of residence as the court of first instance.

**10. Changes to the Terms**
Updated Terms become effective upon posting to this page. Continued use after the update constitutes acceptance of the revised Terms.

**11. Contact**
For all inquiries about these Terms, contact **xchanheex@gmail.com**.`,
  },
  refund: {
    title: 'Refund Policy',
    body: `**Last updated: May 26, 2026**

This Service provides one AI-generated analysis per payment. Because results are delivered automatically upon payment, refunds are handled as follows.

**1. Automatic Refund**
In the following technical-failure cases, **the full payment (6.99 USD) is automatically refunded without any request from you:**
- AI text report generation fails
- AI hairstyle image (6-set) generation fails
- The OpenAI API returns an error preventing result delivery
- A 5xx error occurs during server-side processing

**If either the text report or the hairstyle image fails to generate, no partial delivery is made — the full amount is refunded.** The system sends a refund request to Polar immediately after payment, and your card is credited within **3–5 business days**.

**2. Email Delivery Rules**
- Your report is **automatically emailed to the address you entered at the Polar checkout page**. This Service does not collect a separate email address.
- The email contains the same content as the on-screen report, with the 9 hairstyle images attached as a JPG file.
- **If you mistyped your email address and did not receive the report, you are not eligible for a refund.** Verify that the Polar receipt email arrives correctly — if it does, the report is being sent to the same address.
- If the email is missing, check your **spam folder** first. The on-screen report remains intact, so you can also save it via the "Save Report as Image" button.

**3. Manual Refund**
Within **7 days of payment**, you may email the operator to request review for the following cases:
- The report was generated but has obvious defects (e.g., garbled text, hairstyle image with a clearly different person's face)
- A material defect not covered elsewhere

Please include:
- Polar receipt or order ID (checkout_id / order_id)
- Payment date and first-4 / last-4 of the card
- A specific reason and, if possible, a screenshot of the defective output

The operator will respond with a decision within **3 business days**. Approved refunds are processed via Polar immediately.

**4. Cases Not Eligible for Refund**
- The AI report and hairstyle image were delivered normally but the user is **simply dissatisfied with the result** (subjective preference is not a refund reason).
- The user uploaded a poor-quality photo (blurry, face obscured, photo of someone else) leading to lower-quality results.
- The body information entered does not match reality, leading to inappropriate output.
- **The email address entered at checkout was incorrect**, so the report email was not received (the on-screen report remains intact).
- The refund request is made **more than 7 days after payment**.
- The user was suspended for a Terms violation (e.g., uploading someone else's photo, underage use, face-swap attempts).

**5. Refund Method**
- All refunds are issued to the **original payment method (card)**. Cash refunds, refunds to a different card, store credit, or other forms are not available.
- Refunds are processed via Polar; actual posting to your card may take **3–10 business days** depending on your card issuer.
- Foreign-transaction fees and exchange-rate differences follow your card issuer's policy and are not reimbursed.

**6. Chargebacks**
Before filing a chargeback with your card issuer, please contact the operator by email. Reasonable refund requests are handled promptly. Users who repeatedly file unjustified chargebacks may be suspended without notice, and the operator may submit supporting evidence to the card issuer and Polar.

**7. Contact**
For all refund inquiries, email **xchanheex@gmail.com**. Including \`[Refund Request] <order ID>\` in the subject line speeds up processing.`,
  },
  privacy: {
    title: 'Privacy Policy',
    body: `**Last updated: May 26, 2026**

**1. Information We Collect**

(a) **Information you provide directly**
- One photo of yourself
- Height, weight, gender, leg length, shoulder width, body type
- Consent indications (including age 18+ confirmation)

(b) **Information collected during payment — gathered directly by Polar**
- Payment card details, billing address, email, etc.
- This is collected and processed directly by **Polar Software Inc.** **Card numbers and payment-method specifics are never stored on our servers.**
- This Service receives only the payment ID (checkout_id, order_id), payment amount, payment status, and email address from Polar — solely to verify payment and deliver the report.

(c) **Automatically collected**
- IP address (forwarded to Polar for fraud-prevention)
- General log info: browser type, access time (default Cloudflare infrastructure logs)

**2. Purposes of Processing**
The collected information is used only for:
- Generating the AI style consulting report
- Generating AI hairstyle recommendation images
- Verifying payment and processing refunds
- Emailing the result report to the address provided at checkout
- Preventing abuse and complying with legal obligations

**3. Processing Flow**
1. Your browser scales the photo down to ≤1280px
2. The photo and inputs are sent over HTTPS to our edge server (Cloudflare Pages Functions)
3. The server forwards them to the OpenAI API and receives the analysis
4. The results are returned to your browser and also emailed to the address from Polar via Resend

**4. Processors / Third-Party Sharing**
This Service entrusts processing to the following companies to deliver the Service. Your photos, body info, and payment info are **never sold, shared, or leased to any other third party.**

- **OpenAI, L.L.C.** (United States) — AI model inference / Photo, body info / https://openai.com/policies/privacy-policy
- **Polar Software Inc.** (United States) — Payment processing & refunds / Card details, email, IP / https://polar.sh/legal/privacy
- **Cloudflare, Inc.** (Global) — Hosting and edge runtime / Access logs / https://www.cloudflare.com/privacypolicy/
- **Resend, Inc.** (United States) — Sending the result report email / Recipient email, report body, hairstyle image / https://resend.com/legal/privacy-policy

**5. International Transfers**
Processing takes place on infrastructure in the United States and globally, so your photo, body info, and payment info may be transferred outside the Republic of Korea. By using this Service, you consent to such transfers.

**6. Retention**
- **Our server**: Photos and body info are **not retained long-term.** They live only in transient request memory and are discarded after the response. There is no database storage.
- **OpenAI**: Per their policy, retained for up to 30 days for abuse-monitoring, then deleted. See https://openai.com/policies/api-data-usage-policies
- **Polar**: Payment receipts and refund records are retained for **up to 5 years** to comply with tax/accounting regulations.
- **Cloudflare**: Security and operational logs expire per Cloudflare's own policy.
- **Resend**: Email send records expire per Resend's own policy (currently 30 days).

**7. Your Rights**
You may request:
- Access to your personal data
- Correction of inaccurate data
- Erasure or restriction of processing (subject to legal retention requirements for payment records)
- Withdrawal of consent

Photos and body info are not retained on our servers, so no separate erasure request is needed for them. For payment-record requests, please email the operator.

**8. Minors**
This Service is available only to users **18 or older**. We do not knowingly collect information from children under 14. If we learn such data has been collected, we will delete it promptly.

**9. Cookies & Local Storage**
- We do not use third-party advertising or tracking cookies.
- During checkout we temporarily store input data in your browser's sessionStorage; it is cleared after analysis completes.
- The Polar checkout page may use its own cookies under Polar's policy.

**10. Security Measures**
- All traffic is encrypted with HTTPS (TLS).
- Sensitive credentials (API keys) are kept in environment variables and are never bundled into client code.
- Because photos and body info are not stored on our servers, the risk of long-term data exposure is structurally minimized.

**11. Policy Changes**
This Policy may be updated for legal, policy, or service reasons. Updates take effect upon being posted to this page.

**12. Contact**
For all privacy-related inquiries or rights requests, email **xchanheex@gmail.com**.`,
  },
  aup: {
    title: 'Acceptable Use Policy',
    body: `You may NOT use this Service for any of the following.

**Prohibited Uses**
- Uploading photos, faces, or body images of other people
- Attempting face swaps, deepfakes, identity synthesis, or celebrity composites
- Uploading adult/explicit content, nude photos, or photos of minors
- Use by users under 18
- Seeking medical, diagnostic, diet, or mental-health advice
- Attempting pseudoscientific consulting (fortune-telling, physiognomy, etc.)
- Promoting weapons, drugs, gambling, violence, discrimination, or illegal goods/services
- Using output to defame, harass, or stalk others
- Using output for fraud, deception, or financial inducement
- Automated mass requests (scraping/crawling) or bypassing the API

**Enforcement**
Confirmed violations may result in immediate suspension without notice, and the operator may report violations to the appropriate authorities where required.

**Reporting Abuse**
If you observe another user's violation, please report it to **xchanheex@gmail.com**.`,
  },
};

export const POLICIES = { ko: POLICIES_KO, en: POLICIES_EN };
